// extracted by mini-css-extract-plugin
export default {"tooltip":"jA-z","arrow":"kA-z"};